import { parse } from "avsc"
import {BaseAvroRecord} from "@videoblocks/events-ts/lib/BaseAvroRecord"
import AvroError from "./AvroError"

export default class EventParser {
  /**
   * Parse a record value into a string that can be posted to REST Proxy.
   * @param {BaseAvroRecord} record
   */
  static parseValue(record: BaseAvroRecord): object {
    const type = parse(record.schema(), {
      wrapUnions: true
    })

    try {
      return type.clone(record, {wrapUnions: true})
    } catch (err) {
      throw new AvroError(err.message)
    }
  }

  static getSchema(record: BaseAvroRecord): string {
    return JSON.stringify(record.schema())
  }

  static getTopic(record: BaseAvroRecord): string {
    return EventParser.toKebabCase(record.schema().name)
  }

  static getInvalidTopic(record: BaseAvroRecord): string {
    return "invalid-" + EventParser.getTopic(record)
  }

  private static toKebabCase(str: string): string {
    return str
      .split(/(?=[A-Z])/)
      .join("-")
      .toLowerCase()
  }
}
